// extracted by mini-css-extract-plugin
module.exports = {"root":"_2NY7UG","header":"_1WHqnO","title":"_1BuDj5","browseButton":"EoqRmX","collections":"_2kBJB1","item":"_1vKX2T","loader":"_8lb4Uw"};